import * as React from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import { getCurrentLocale, getMessages } from './selectors';

export interface ILanguageProviderProps {
  locale: string;
  children: React.ReactNode;
  messages: any;
}

const LocaleProvider: React.FunctionComponent<ILanguageProviderProps> = props => {
  return <IntlProvider {...props} defaultLocale="en" />;
};

export default connect(store => {
  return {
    locale: getCurrentLocale(store),
    messages: getMessages(store),
  };
})(LocaleProvider);



// WEBPACK FOOTER //
// ./src/containers/LocaleSettings/LocaleProvider.tsx